var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNonvegIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 18C14.8137 18 17.5 15.3137 17.5 12C17.5 8.68629 14.8137 6 11.5 6C8.18629 6 5.5 8.68629 5.5 12C5.5 15.3137 8.18629 18 11.5 18Z",
    fill: "#E63328"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 2H1.5V22H21.5V2Z",
    stroke: "#E63328",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonvegIcon);
export default __webpack_public_path__ + "static/media/nonveg-icon.dcac5d4cb5b6bbdc29ef8dee3978e1ee.svg";
export { ForwardRef as ReactComponent };